
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M5.12244 13.2087L14.4632 20.0582C15.151 20.746 17.2416 19.7702 19.1332 17.8787C21.0248 15.9871 22.0005 13.8965 21.3127 13.2087L14.4632 3.86792"></path><path d="M11.6601 10.4063C14.2394 7.82703 15.4939 4.89976 14.4622 3.86806C13.4305 2.83635 10.5032 4.09089 7.92396 6.67016C5.34469 9.24942 4.09015 12.1767 5.12185 13.2084C6.15356 14.2401 9.08083 12.9856 11.6601 10.4063Z"></path><path d="M3 20.2387C3 19.2657 4.76125 16.7162 4.76125 16.7162C4.76125 16.7162 6.5225 19.2657 6.5225 20.2387C6.5225 21.2118 5.73434 22 4.76125 22C3.78816 22 3 21.2118 3 20.2387Z"></path><path d="M14.4481 12.3131H17.9706C18.9631 12.3131 19.8597 11.9026 20.5 11.2421C21.1147 10.608 21.4931 9.74347 21.4931 8.79063C21.4931 6.84533 19.9159 5.26813 17.9706 5.26813H15.4899"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiColor",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
